<template>
  <div id="login">
    <el-image v-if="noLogo==='0'" :src="logo_url"
              style="width:auto;height:auto;padding-left:64px;padding-top:52px"></el-image>
    <div id="login_k">
      <!--   :rules="rules"(定义的变量，以及=后面的规则) ; :model="loginForm"数据对象 -->
      <el-form :rules="rules" :model="loginForm" class="loginContainer">
        <h3 class="loginTitle">欢 迎 登 录</h3>
        <h5 v-if="noLogo==='0'" class="loginTitle1">叨 叨 科 技 物 联 网 平 台</h5>
        <h5 v-else class="loginTitle1">{{ noLogo }}</h5>
        <!--  可以不加prop属性，因为规则中加了required校验，所以需要添加-->
        <el-form-item prop="username">
          <el-input type="text" v-model="loginForm.username" auto-complete="off"
                    style="width:300px;height:30px;" placeholder="请输入账号"
                    prefix-icon="el-icon-user" aria-placeholder="请输入用户名"/>
        </el-form-item>
        <el-form-item prop="password">
          <el-input size="normal" type="password" v-model="loginForm.password" auto-complete="off"
                    style="width:300px;height:30px;" placeholder="请输入密码"
                    prefix-icon="el-icon-menu" aria-placeholder="请输入密码" show-password/>
        </el-form-item>
        <el-form-item prop="projectName">
          <el-input type="text" v-model="loginForm.projectName" auto-complete="off"
                    style="width:300px;height:30px;" placeholder="请输入项目名称"
                    prefix-icon="el-icon-collection-tag" aria-placeholder="请输入项目名称"/>
        </el-form-item>
        <el-form-item>
          <el-input type="text" v-model="loginForm.captcha" style="width:150px;"
                    placeholder="请输入图中验证码" aria-placeholder="请输入图中验证码"/>
          <el-button type="primary" icon="el-icon-refresh-right" class="icon-centered"
                     @click="onCapcha"
                     style="float:right;margin-right:1px;width:40px;height:39px;font-size:20px"/>
          <el-image :src="url" :fit="fit" style="float:right;margin-right:0px;width:100px;height:42px"/>
        </el-form-item>
        <el-button @click="onLogin" size="normal" type="primary" style="width:100%;">登录
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>

import CryptoJS from "crypto-js";

export default {
  name:"login",
  components:{ /*引入组件*/

  },
  data() {
    return {
      // projectId: 'saas_school_20230531',
      isBle:"0",
      noLogo:"0",
      msg:'I am dataFind',
      fit:"fill",
      url:"",
      captchaId:"",
      logo_url:require('@/assets/logo.png'),
      config:{
        color:"201, 201, 201",
        opacity:1,  /*线的透明值*/
        zIndex:0,  /*特效显示的优先层级*/
        count:200 /*漂浮点的数量*/
      },
      loginForm:{ /*数据对象*/
        projectName:'',
        username:'',
        password:'',
        captcha:''
      },
      rules:{ /*规则*/
        projectName:[{required:true,message:'请输入项目名',trigger:'blur'}],
        username:[{required:true,message:'请输入用户名',trigger:'blur'}],
        password:[{required:true,message:'请输入密码',trigger:'blur'}],
        captcha:[{required:true,message:'请输入验证码',trigger:'blur'}]
      }
    };
  },
  methods:{ /*方法存放*/
    get_yzm() {
      const params = {};
      this.$api.post(this.$urls.ip + this.$urls.captcha,params).then(res => {
        console.log(res.data.data);
        this.captchaId = res.data.data["captchaId"];
        this.url = res.data.data["picPath"];
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取验证码失败");
        }
      });
    },
    onCapcha() {
      this.get_yzm();
    },
    onLogin() { /*登录*/
      const params = {
        'username':this.loginForm.username,
        'password':CryptoJS.MD5(this.loginForm.password).toString(),
        // 'password': this.loginForm.password,
        // achang22/hyop%$#(*S1G)NB
        'captchaId':this.captchaId,
        'projectName':this.loginForm.projectName,
        'captcha':this.loginForm.captcha
      };
      let loading = this.$load.service({spinner:"",text:"正在加载中...",background:"rgba(0, 0, 0, 0.3)"});
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.login,params).then(res => {
        console.log(res.data.data);
        this.get_info(res.data.data["projectId"],res.data.data["token"]["access_token"]);
        loading.close();
        let userName = res.data.data["userName"];
        let nickName = res.data.data["nickName"];
        let projectId = res.data.data["projectId"];
        let userId = res.data.data["id"];
        let token = res.data.data["token"]["access_token"];
        // this.$message.error("登录成功")
        localStorage.setItem("username",this.loginForm.username);
        // localStorage.setItem("password", this.loginForm.password);
        localStorage.setItem("token",token);
        localStorage.setItem("userName",userName);
        localStorage.setItem("nickName",nickName);
        localStorage.setItem("userId",userId); /*用户id*/
        localStorage.setItem("projectId",projectId);
        localStorage.setItem("projectName",this.loginForm.projectName);
        this.$router.push({ /*路由跳转传值*/
          path:'/home'
        });
      }).catch(error => {
        console.log(error);
        loading.close();
        if (error) {
          this.$message.error("登录失败");
        }
        this.get_yzm();
      });
    },
    get_info(projectId,access_token) {
      const params = {
        "projectId":projectId
      };
      const headers = {
        'token':access_token
      };
      this.$api.post(this.$urls.ip + this.$urls.getProjectInfo,params,headers).then(res => {
        console.log("项目信息，",res.data.data);
        let d = res.data.data;
        if (d.isBle) {
          localStorage.setItem("isBle","1");
        } else {
          localStorage.setItem("isBle","0");
        }
        localStorage.setItem("projectType","" + d.type); /*1、通用项目 2、会所*/
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取项目信息失败");
        }
      });
    },
    get_ip() {
      this.$api.get("ipConfig.json")  /*替换全局ip*/
           .then(res => {
        console.log(res.data);
        this.$urls.ip = res.data["baseUrl"];
        this.$urls.websocketUrl = res.data["websocketUrl"];
        localStorage.setItem("srv_ip",this.$urls.ip);
        localStorage.setItem("websocketUrl",this.$urls.websocketUrl);
        this.noLogo = res.data["name"];
        localStorage.setItem("noLogo","" + res.data["name"]);
        // this.isBle = res.data["isBle"];
        // localStorage.setItem("isBle","" + res.data["isBle"]);
        // localStorage.setItem("project","" + res.data["project"]);
        this.get_yzm();
      }).catch(error => {
        console.log(error);
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.get_ip();
    // this.$urls.ip = "https://pt.daodaosmart.com:9080"
    // this.$urls.websocketUrl = "wss://pt.daodaosmart.com:12000"
    // this.$urls.ip = "http://192.168.1.220:9080"
    // this.$urls.websocketUrl = "wss://192.168.1.220:12000"
    // localStorage.setItem("isBle", '0');
    // localStorage.setItem("srv_ip", this.$urls.ip);
    // localStorage.setItem("websocketUrl", this.$urls.ws);
    this.loginForm.username = localStorage.getItem("username") || "";
    this.loginForm.projectName = localStorage.getItem("projectName") || "";
    this.loginForm.password = localStorage.getItem("password") || "";
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
@import '../assets/css/icon_login.css';

#login {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
}

#login_k {
  z-index: 3; /*设置显示优先级*/
  position: absolute;
  top: 25vh;
  right: 20vh;
}

.loginTitle {
  margin: 20px auto 20px auto; /*上 右 下 左*/
  text-align: center;
  color: #2269DD;
  font-size: 32px;
}

.loginTitle1 {
  margin: 5px auto 40px auto; /*上 右 下 左*/
  text-align: center;
  color: #505552;
  font-size: 18px;
}

.icon-centered {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button__icon {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue